module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("по рассылке " + _vm._s(_vm.campaign.name))]), _vm._v(" "), _c('div', {
    staticClass: "jump-target"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.calltasks), function(calltask) {
    return _c('tr', [_c('td', [(calltask.testing) ? _c('strong', [_vm._v(_vm._s(calltask.phone))]) : _vm._e(), _vm._v(" "), (!calltask.testing) ? _c('div', [_vm._v(_vm._s(calltask.phone))]) : _vm._e()]), _vm._v(" "), _c('td', [(calltask.testing) ? _c('strong', [_vm._v(_vm._s(_vm.getCallTaskState(calltask.state)))]) : _vm._e(), _vm._v(" "), (!calltask.testing) ? _c('div', [_vm._v(_vm._s(_vm.getCallTaskState(calltask.state)))]) : _vm._e()])])
  }), 0)])]), _vm._v(" "), _c('back-to-top', {
    attrs: {
      "target": ".jump-target"
    }
  }, [_c('button', {
    staticClass: "button"
  }, [_vm._v("Наверх")])])], 1), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-light",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', [_vm._v("Закрыть")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Телефон")]), _vm._v(" "), _c('th', [_vm._v("Состояние")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9e3546ba"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/calltasks/CalltasksCampaign.vue
// module id = 468
// module chunks = 40